import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

const Container = styled(Box)({
    display: 'flex',
    borderRadius: '6px',
    overflow: 'hidden',
    width: '100%',
    maxWidth: 450,
    backgroundColor: '#fff',
});

const InputField = styled(TextField)({
    flex: 1,
    '& .MuiOutlinedInput-root': {
        borderRadius: 0,
        height: '40px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
    },
    '& input': {
        padding: '10px 12px',
    },
});

const SubmitButton = styled(Button)({
    '&:hover': {
        transform: 'none',
    },
    fontWeight: 'bold',
    height: '40px',
    borderRadius: 0,
    whiteSpace: 'nowrap',
});

function TextWithButton({ placeholder = '', variant = "outlined", buttonText, onSubmit, onChange, color, sx, ...rest }) {
    const [value, setValue] = useState('');

    const buttonProps = {
        color,
        sx
    }

    const handleClick = (e) => {
        if(typeof onSubmit == 'function'){
            e.preventDefault();
            onSubmit();
        }
    };

    const handleChange = (e) => {
        setValue(e.target.value);
        if(typeof onChange == 'function'){
            onChange(e);
        }
    }

    return (
        <Container>
            <InputField
                variant={variant}
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
                {...rest}
            />
            <SubmitButton {...buttonProps} type="submit" onClick={handleClick}>
                {buttonText}
            </SubmitButton>
        </Container>
    );
}

export default TextWithButton;
